import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Responsive toolbar for dashboard actions — stacks full-width on mobile, row on sm+.
 * Child buttons inherit min touch height and width without duplicating classes.
 */
export function ActionBar({ className, children, ...rest }) {
  return (
    <div
      className={cn(
        'flex w-full min-w-0 flex-col items-stretch gap-2 sm:flex-row sm:flex-wrap sm:items-center sm:justify-end',
        '[&_button]:inline-flex [&_button]:w-full [&_button]:min-h-[44px] [&_button]:touch-manipulation [&_button]:justify-center sm:[&_button]:w-auto',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
